import { STATUS } from "@/utils/constants";

import { SET_IS_GENERATING_PREVIEW_PDF_STATUS } from "./generatePdf.actionTypes";

const initialState = {
  isGeneratingPreviewPdfStatus: STATUS.IDLE,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_IS_GENERATING_PREVIEW_PDF_STATUS: {
      return { ...state, isGeneratingPreviewPdfStatus: action.payload };
    }

    default:
      return state;
  }
};
